import React, { useState } from 'react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Flex,
  Text,
  useMediaQuery,
} from '@chakra-ui/react'
import { VIEW_AS } from '../consts'
import { PeriodTabStrip } from '../components/PeriodTabStrip'
import Header from '../../../app/components/Header'
import { ViewAsSelector } from '../components/ViewAsSelector'
import { BarChart } from '../widgets/BarChart'
import { PieChart } from '../widgets/PieChart'
import { ListView } from '../widgets/ListView'
import { ElectricityCost } from '../widgets/ElectricityCost'
import { Controls } from '../widgets/Controls'
import { DeviceGroups } from '../widgets/DeviceGroups'

const Dashboard: React.FC<{ data: any; overviewFetching: boolean }> = ({
  data,
  overviewFetching,
}) => {
  const [viewAs, setViewAs] = useState(VIEW_AS[0])

  const [isSmallerThan1200] = useMediaQuery('(max-width: 1200px)')
  const HeaderContent = <Header title="Overview" />

  return (
    <>
      {!isSmallerThan1200 && HeaderContent}
      <Flex direction={{ base: 'column', desktopLg: 'row' }} gap={8}>
        <Flex width="100%" height="fit-content" gap={6} direction="column" borderRadius="xl" p={4} bg="white" boxShadow="sm">
          <Flex direction={{ base: 'row', desktopLg: 'column', overviewLg: 'row' }} gap={{ base: 0, desktopLg: 3, overviewLg: 0 }} alignItems="center" width="100%" justifyContent="space-between">
            <Flex gap={3}>
              <Text color="#484848" fontWeight="700" fontSize="18px">Locations</Text>
              <PeriodTabStrip />
            </Flex>
            <ViewAsSelector viewAs={viewAs} setViewAs={setViewAs} />
          </Flex>
          {data?.length > 0 ? (
            <Flex alignItems="center" px={5}>
              {viewAs.id === 1 && <BarChart data={data} />}
              {viewAs.id === 2 && <PieChart data={data} />}
              {viewAs.id === 3 && <ListView data={data} />}
            </Flex>
          ) : (
            <Alert
              status="info"
              bg="blue.50"
              borderRadius="md"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              height="200px"
              color="blue.800"
            >
              <AlertIcon boxSize="40px" mr={0} color="blue.500" />
              <AlertTitle mt={4} mb={1} fontSize="lg" fontWeight="bold">
                No data available for the selected period
              </AlertTitle>
              <AlertDescription maxWidth="sm" fontSize="sm" color="blue.700">
                Try choosing a different date range to check for available data.
              </AlertDescription>
            </Alert>
          )}
        </Flex>
        <Flex direction="column" gap={5}>
          <ElectricityCost />
          <Controls />
          <DeviceGroups />
        </Flex>
      </Flex>
    </>
  )
}

export default Dashboard
